import { Component, Inject, OnInit } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-home-welcome-new-employee-popup',
  templateUrl: './home-welcome-new-employee-popup.component.html',
  styleUrls: ['./home-welcome-new-employee-popup.component.scss'],
})
export class HomeWelcomeNewEmployeePopupComponent implements OnInit {
  buttonColorName: any;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  emailSubject: any;
  readonly employeeName: string = '{{EMPLOYEE_NAME}}';
  readonly senderName: string = ' <br /><br />Best regards, <br /><br />{{SENDER_NAME}} <br /><br/>{{SENDER_DESIGNATION}}';

  emailContentBody: string = '';
  isValidEmailSubject: any = true;
  isValidEmailContentBody: any = true;
  isHideEmployeeInfo: any;
  employeeList: any = [];
  popupName: any;
  isHideSendWishBtn: any = false;
  isDisabledEmailContent: any = false;
  // test-editor.component.ts
  // editorConfig: AngularEditorConfig = {
  //   editable: true,
  //   spellcheck: true,
  //   height: '300px',
  //   minHeight: '0',
  //   maxHeight: 'auto',
  //   width: '100%',
  //   minWidth: '0',
  //   translate: 'yes',
  //   enableToolbar: true,
  //   showToolbar: true,
  //   placeholder: 'Enter Email here...',
  //   defaultParagraphSeparator: 'p',
  // };
  editorConfig: any = {
    height: 500,
    toolbarSticky: false,
    toolbarAdaptive: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: 'insert_clear_html',
    uploader: {
      insertImageAsBase64URI: true // 💡 This enables local image embedding
    },
    buttons: [
      'bold', 'italic', 'underline', '|',
      'ul', 'ol', '|',
      'link', 'image', '|',
      'undo', 'redo', '|',
      'fontsize'
    ]
  };




  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private httpService: HttpService, private toastr: ToastrService,
    private config: Config, private encryptionService: EncryptionService, public dialogRef: MatDialogRef<HomeWelcomeNewEmployeePopupComponent>, public mobileResponsiveService: MobileResponsiveService) { }


  ngOnInit() {
    // Fetch and set basic session data
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(
      this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID'))
    );
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    console.warn(this.data?.employeeList);

    this.popupName = this.data?.popupName;


    setTimeout(() => {
      if (this.popupName === 'notification') {
        this.emailSubject = this.data?.employeeList?.wishSubject || '';
        this.emailContentBody = this.data?.employeeList?.wishes || '';
        this.isHideSendWishBtn = false;
        this.isDisabledEmailContent = true;

        // Only apply fallback if no wish body exists
        if (!this.emailContentBody?.trim()) {
          this.emailContentBody = this.getDefaultEmailTemplate();
        }

      } else {
        this.isHideSendWishBtn = true;
        this.isDisabledEmailContent = false;

        const list = this.data?.employeeList;

        if (Array.isArray(list) && list.length) {
          this.employeeList = list;
          this.isHideEmployeeInfo = false;
        } else if (list) {
          this.employeeList.push(list);
          this.isHideEmployeeInfo = true;
        }

        this.emailContentBody = this.getDefaultEmailTemplate(); // set for non-notification
      }
    }, 300);


  }



  getDefaultEmailTemplate(): string {
    return `
    <div contenteditable="false" style="padding: 4px; border-radius: 5px; display: inline-block;">
      Dear ${this.employeeName},
    </div> 
    <br /><br />
    I hope this message finds you well. <br /><br />
    I wanted to take a moment to extend my warmest wishes to you on 
    [specific occasion or reason, e.g., your work anniversary, your recent promotion, your birthday]. 
    It's a pleasure to work with someone as dedicated and talented as you, 
    and I wanted to let you know how much your contributions are valued. <br /><br />
    [Include any additional personal note or well-wishing relevant to the occasion.] <br /><br />
    Wishing you continued success and happiness. <br /><br />
    <div contenteditable="false" style="padding: 4px; border-radius: 5px; display: inline-block;">
      Sincerely,<br />
      ${this.senderName}
    </div>
  `;
  }

  isCheckEmailSubject(event: any) {
    if (event.target.value != undefined || event.target.value != null) {
      this.isValidEmailSubject = true;
    } else {
      this.isValidEmailSubject = false;
    }
  }


  
  toastShown = false;

  checkMaxLength(comment: string) {
    if (comment?.length === 255 && !this.toastShown) {
      this.toastShown = true;

      this.toastr.error('Maximum limit is 255 characters', 'Limit Reached');

      setTimeout(() => {
        this.toastShown = false;
      }, 3000); // Reset after 3s so it can show again next time
    }
  }


  sendWishes() {
    this.isValidEmailSubject = this.emailSubject?.trim();
    this.isValidEmailContentBody = this.emailContentBody?.trim();

    if (!this.isValidEmailSubject || !this.isValidEmailContentBody) {
      return;
    }

    const request = {
      body: this.emailContentBody,
      companyId: this.loggedInUserCompanyID,
      fromUser: Number(this.loggedInUserId),
      subject: this.emailSubject,
      toUser: this.employeeList?.map((ele: any) => ele.id),
      type: this.popupName,
    };

    this.httpService.callPostService(this.config.sendWishes, request).subscribe((result: any) => {
      this.dialogRef.close();
    });
  }


}
